import { createIcon } from '@chakra-ui/icons';

export const Media = createIcon({
  displayName: 'Media',
  viewBox: '0 0 14 15',
  path: [
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
      <g clipPath="url(#clip0_454_5200)">
        <path
          d="M5.25 5.75C5.73325 5.75 6.125 5.35825 6.125 4.875C6.125 4.39175 5.73325 4 5.25 4C4.76675 4 4.375 4.39175 4.375 4.875C4.375 5.35825 4.76675 5.75 5.25 5.75Z"
          fill="currentColor"
        />
        <path
          d="M14 11H12.25V9.25H10.5V11H8.75V12.75H10.5V14.5H12.25V12.75H14V11Z"
          fill="currentColor"
        />
        <path
          d="M7 12.75H1.75V2.25H12.25V7.5H14V1.375C14 1.14294 13.9078 0.920376 13.7437 0.756282C13.5796 0.592187 13.3571 0.5 13.125 0.5H0.875C0.642936 0.5 0.420376 0.592187 0.256282 0.756282C0.0921872 0.920376 0 1.14294 0 1.375L0 13.625C0 13.8571 0.0921872 14.0796 0.256282 14.2437C0.420376 14.4078 0.642936 14.5 0.875 14.5H7V12.75Z"
          fill="currentColor"
        />
        <path
          d="M10.1745 8.59987L8.75 5.75L6.125 9.25L4.375 7.5L2.625 11H7.99837C8.13995 10.4538 8.41191 9.95004 8.79093 9.53201C9.16995 9.11398 9.64471 8.79412 10.1745 8.59987Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_454_5200">
          <rect width="14" height="14" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
